module.exports = __webpack_public_path__ + "media/src/images/partners/hertie-f3bc0ef1fcbeb453846d6b16b6368457.jpg";